import axios from "../../config/axiosConfig";

export default {
  support: (message) => axios.post("/support", message),
};


